import { render } from "./NoData.vue?vue&type=template&id=6e113cac&scoped=true"
const script = {}

import "./NoData.vue?vue&type=style&index=0&id=6e113cac&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e113cac"]])

export default __exports__